import { useState } from "react";
import Loader from "../../components/main/Loader";
import { initialParams, IPagination } from "../../helpers/PaginationHelper";
import { useGetUserRoleQuery } from "../../store/services/LookUpService";
import { useDownloadReportEsitoMutation } from "../../store/services/ReportService";
import { toast } from "react-toastify";
import { saveAs } from 'file-saver';
import ReportEsitoFilters from "../../components/filters/ReportEsitoFilters";
import { AdapterReportFilterEsito } from "../../helpers/adapter/filters/AdapterFilterReportEsito";

export default function ReportEsito() {
    const [queryParams, setQueryParams] = useState<IPagination>(initialParams);
    const [filterParams, setFilterParams] = useState<any>(null);
    let { data: speakerData, isLoading: isLoadingSup } = useGetUserRoleQuery({role: 'Speaker' });
    const [getReportEsito, requestReport] = useDownloadReportEsitoMutation()
    

    const handleSetFilter = async (dataFilter: any) => {
        const mapFilter = AdapterReportFilterEsito(dataFilter)
        setFilterParams(mapFilter);
        setQueryParams(initialParams);
        let result: any = await getReportEsito(mapFilter);

        if ('error' in result) {
            console.log('ERROR DOWNLOAD')
        } else {
            saveAs(result?.data, `StatisticheCambioEsito_${Date.now()}.xlsx`)
            toast.success(`Report scaricato`);
        }
    }

    return(
        <>
            { ( isLoadingSup || requestReport.isLoading) ? <Loader /> : null}
            <ReportEsitoFilters methodParent={handleSetFilter} speakerData={speakerData} />
            {requestReport?.isError 
                ? 
                <div className="mt-8 bg-red-100 border-l-4 border-red-500 text-red-700 p-4" role="alert">
                    <p className="font-bold">Attenzione</p>
                    <p>Nessun risultato presente per i parametri selezionati</p>
                </div>
                : null
            }
        </>
    )
}